
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AlertService } from 'app/core/alert.service';
import { CannedMessage, ResponseWithWarnings } from 'app/core/CannedMessage';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class ErrorHandlerService {
  private alertService = inject(AlertService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
  handleError = (err: HttpErrorResponse):
      Observable<any> => {
    const cannedMessage: CannedMessage = {};
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.log('An error occurred:', err.error.message);
    } else {
      let alertSent = false;
      cannedMessage.code = err.status;
      cannedMessage.title = err.statusText;
      if (err.status === 401) {
        cannedMessage.title +=
                ' Please logout (Your session must have been expired, or you are no more authorized to work on this area )';
      }
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      const res = err.error;
      if (res) {
        if (typeof res === 'string') {
          try {
            const tmp = JSON.parse(res);
            if (tmp.hasOwnProperty('errors') && tmp['errors'] instanceof Array) {
              tmp['errors'].forEach((message: CannedMessage) => {
                this.showErrorMessage(message);
                alertSent = true;
              });

            } else if (
              tmp.hasOwnProperty('data') && typeof tmp['data'] === 'object' &&
                    tmp['data'].hasOwnProperty('errors') &&
                    tmp['data']['errors'] instanceof Array) { /** mockup */
              tmp['data']['errors'].forEach((message: CannedMessage) => {
                this.showErrorMessage(message);
                alertSent = true;
              });
            }
          } catch (e) {
            this.alertService.error(res, `${err.status || ''}`);
            alertSent = true;
          }
        } else if (typeof res === 'object') {
          if (res.hasOwnProperty('errors') && res['errors'] instanceof Array) {
            res['errors'].forEach((message: CannedMessage) => {
              this.showErrorMessage(message);
              alertSent = true;
            });
          } else if (
            res.hasOwnProperty('data') && typeof res['data'] === 'object' &&
                  res['data'].hasOwnProperty('errors') && res['data']['errors'] instanceof Array) {
            /** mockup */
            res['data']['errors'].forEach((message: CannedMessage) => {
              this.showErrorMessage(message);
              alertSent = true;
            });
          } else {
            const message = this.getMessageText(res as CannedMessage & { message?: string; reason?: string });
            if (message) {
              this.alertService.error(message, `${err.status || ''}`);
              alertSent = true;
            }
          }
        }
      }
      if (!alertSent) {
        this.alertService.error(cannedMessage.title || '', `${cannedMessage.code || ''}`);
      }
    }

    return EMPTY;
  }

  private showErrorMessage(message: CannedMessage & { message?: string; reason?: string }): void {
    this.alertService.error(this.getMessageText(message), `${message.code || message.status || ''}`);
  }

  private getMessageText(message: CannedMessage & { message?: string; reason?: string }): string {
    return message.title || message.detail || message.message || message.reason || '';
  }

  handleWarning = (res: ResponseWithWarnings) => {
    if (res && res.hasOwnProperty('warnings') && res['warnings'] instanceof Array) {
      res['warnings'].forEach((message: CannedMessage) => {
        if (message.warningType === 'warning') {
          this.alertService.warn(message.title || '', `${message.code || ''}`);
        } else {
          this.alertService.success(message.title || '', `${message.code || ''}`);
        }
      });
    }
  }
}
